import { Suspense, type ComponentProps, type ReactNode } from 'react';

type FormProps = ComponentProps<'form'> & {
	fallback?: ReactNode;
	handleSubmit: () => void;
};

export function Form({ fallback, handleSubmit, children, ...props }: FormProps) {
	return (
		<form
			{...props}
			onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				handleSubmit();
			}}
		>
			{fallback ? <Suspense fallback={fallback}>{children}</Suspense> : children}
		</form>
	);
}
